import "./App.css";
import WeatherApp from "./Components/WeatherApp";

function App() {
  return (
    <div>
      <WeatherApp />
    </div>
  );
}

export default App;
